import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input data-testid={testId} type={show ? "text" : "password"} className="pr-10" {...props} />
      <button
        type="button"
        data-testid={`${testId}-toggle`}
        aria-label={show ? "Hide password" : "Show password"}
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-brand transition-colors"
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
};
